import { HttpRequest } from "../utils"

/**
 * Consignment offering catalog (R14).
 *
 * Returns offering items configured by **all suppliers for the current
 * retailer business**, suitable for merging into the buyer-sales product
 * grid. Frontend treats them as additional product rows with an
 * `isConsignment: true` marker; cart accepts them transparently and the
 * `consignmentOfferingItemId` is forwarded to the order submission endpoint
 * (backend split logic — multi-order/DeliveryNote — is server-side).
 *
 * Backend stub needed (Phase G18d slice):
 *   POST /ord/consignment-offering/for-retailer/items
 *   body: { businessId: string, search?, categoryId? }
 *   resp: {
 *     items: Array<{
 *       offeringId: string
 *       offeringItemId: string
 *       productId: string
 *       variantId: string
 *       skuCode?: string
 *       nameMon?: string
 *       image?: string
 *       category?: { id, name }
 *       brand?: { id, name }
 *       supplierBusinessId: string
 *       supplierName: string
 *       salePrice: number          // supplier B2C price (offering)
 *       availableStock: number     // ConsignmentInventory.available
 *       commissionPercent?: number
 *     }>
 *   }
 */

const httpRequest = new HttpRequest()

export interface ForRetailerBody {
  businessId: string
  search?: string
  categoryId?: string
}

export const forRetailer = async (body: ForRetailerBody) => {
  return httpRequest.post(
    "/ord/consignment-offering/for-retailer/items",
    body as never,
  )
}

/**
 * R16 §4.6 — VMI auto-approve toggle (per-retailer, per-supplier).
 *
 * Persists "next 30 days, auto-AUTHORIZE replenishment orders coming from this
 * retailer". Backend stub: POST /ord/consignment-offering/vmi-auto-approve
 * (proxy → de-consignment-service offering settings flag).
 */
export interface VmiAutoApproveBody {
  retailerBusinessId: string
  /** When true, supplier consents to auto-approve VMI replenishments. */
  enabled: boolean
  /** ISO date — when enabled, default = now + 30 days. */
  expiresAt?: string | null
}

export const setVmiAutoApprove = async (body: VmiAutoApproveBody) => {
  return httpRequest.post(
    "/ord/consignment-offering/vmi-auto-approve",
    body as never,
  )
}
